/**
 * NavBar.js - Shared navigation bar for authenticated pages
 */

import React from 'react';
import { useTheme } from '../context/ThemeContext';
import Logo from './Logo';
import './NavBar.css';

function NavBar({ user, onHome, onAdmin, onContact, onHelp, onSettings, onCaptains, onVenues, onReferees, onTournaments, onLogout }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <button className="navbar-brand" onClick={onHome}>
          <Logo size="1.4rem" />
        </button>
        <div className="navbar-actions">
          <span className="navbar-user">{user?.name}</span>
          {onAdmin && (
            <button className="navbar-link" onClick={onAdmin}>
              Admin
            </button>
          )}
          <button className="navbar-link" onClick={onCaptains}>
            Captains
          </button>
          {onTournaments && (
            <button className="navbar-link" onClick={onTournaments}>
              Tournaments
            </button>
          )}
          {onVenues && (
            <button className="navbar-link" onClick={onVenues}>
              Venues
            </button>
          )}
          {onReferees && (
            <button className="navbar-link" onClick={onReferees}>
              Referees
            </button>
          )}
          <button className="navbar-link" onClick={onSettings}>
            Settings
          </button>
          <button className="navbar-link" onClick={onContact}>
            Contact
          </button>
          <button className="navbar-link" onClick={onHelp}>
            Help
          </button>
          <button
            className="navbar-theme-toggle"
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? '\u2600' : '\uD83C\uDF19'}
          </button>
          <button className="navbar-link navbar-logout" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
